// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RadarChartOutlinedSvg from "@fishx/icons-svg/es/asn/RadarChartOutlined";
import FishxIcon from '../components/FishxIcon';

var RadarChartOutlined = function RadarChartOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RadarChartOutlinedSvg
  }));
};

RadarChartOutlined.displayName = 'RadarChartOutlined';
export default React.forwardRef(RadarChartOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RadarChartOutlined.js
// module id = 3955
// module chunks = 0